(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-md-main-product"]) return;
  try {
    
  (function () {
    function initVideoPlayOnView() {
      const slides = document.querySelectorAll('.product-gallery-container .product-images__slide-video');

      if (!slides.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;

            const video = entry.target.querySelector('video');
            if (!video) return;

            // iOS autoplay requirements
            video.muted = true;
            video.playsInline = true;
            video.autoplay = true;

            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
          });
        },
        {
          threshold: [0.6], // play when 60% visible
        }
      );

      slides.forEach((slide) => observer.observe(slide));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoPlayOnView);
    } else {
      initVideoPlayOnView();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initVideoPlayOnView() {
      const slides = document.querySelectorAll('.product-gallery-container .product-images__slide-video');

      if (!slides.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;

            const video = entry.target.querySelector('video');
            if (!video) return;

            // iOS autoplay requirements
            video.muted = true;
            video.playsInline = true;
            video.autoplay = true;

            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
          });
        },
        {
          threshold: [0.6], // play when 60% visible
        }
      );

      slides.forEach((slide) => observer.observe(slide));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoPlayOnView);
    } else {
      initVideoPlayOnView();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
